import React, { useEffect, useState } from 'react';
import RequestAccess from "../components/RequestAccess";

const FreeMasterclass = () => {
  const [showForm, setShowForm] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {/* Keyframe animation for button */}
      <style>{`
        @keyframes wiggle {
          0% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
          100% { transform: translateX(0); }
        }
        .wiggle-button {
          animation: wiggle 0.5s ease-in-out infinite;
        }
      `}</style>

      <div
        style={{
          margin: 0,
          fontFamily: 'Arial, sans-serif',
          background: 'linear-gradient(to bottom, #020024 100%, #090979 30%, #000000 100%)',
          color: 'white',
        }}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', padding: isMobile ? '30px 15px' : '40px 20px' }}>
          <div
            style={{
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              borderRadius: '40px',
              padding: '12px 20px',
              fontSize: '15px',
              fontWeight: '500',
              display: 'inline-block',
              background: 'transparent',
              letterSpacing: '0.5px',
            }}
          >
            ChatGPT Mastery Course with 3000+ Prompts
          </div>

          <h1 style={{ fontSize: isMobile ? '26px' : isTablet ? '30px' : '36px', lineHeight: 1.4 }}>
            Master ChatGPT With Our  <span style={{ color: '#fa513a' }}> Course And 3000+ </span>
            <br />
             Powerful Prompts Turn Ideas into Income Fast. 
          </h1>
          <p style={{ fontSize: '15px', marginTop: '10px' }}>
            You Can Earn in Thousand, lakhs, Crore, Just ChatGPT in Correct Way
          </p>
        </div>

        {/* Main Section */}
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: 'flex-start',
            padding: '0 20px 40px',
            gap: '40px',
            flexWrap: 'wrap',
          }}
        >
          {/* Left Video */}
          <div
            style={{
              flex: 1,
              minWidth: '300px',
              maxWidth: isMobile ? '100%' : '600px',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                position: 'relative',
                paddingBottom: '56.25%',
                height: 0,
                overflow: 'hidden',
                borderRadius: '12px',
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/tKmtebtz3SI"
                title="Free Masterclass Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: isMobile ? '100%' : '80%',
                  height: isMobile ? '100%' : '90%',
                  borderRadius: '12px',
                  marginLeft: isMobile ? '5%' : '20%',
                }}
              />
            </div>
          </div>

          {/* Right Info Boxes */}
          <div style={{ flex: 1, minWidth: '300px', padding: '10px' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                gap: '20px',
              }}
            >
              {[
                { label: '3000+ Ready Prompts For any industry or project.' },
                { label: 'Quick Learning Short, easy-to-follow video course.' },
                { label: 'Save Time Create content and ideas in minutes.' },
                { label: 'Earn More Turn skills into income opportunities.' },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '20px',
                    padding: '15px',
                    color: 'white',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    textAlign: 'center',
                  }}
                >
                  <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>

            {/* Button */}
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
              <button
                className="wiggle-button"
                style={{
                  background: 'linear-gradient(to right, #f8b500, #e68a00)',
                  color: 'black',
                  fontSize: isMobile ? '18px' : '20px',
                  padding: isMobile ? '12px 30px' : '14px 40px',
                  border: 'none',
                  borderRadius: '14px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  width: isMobile ? '100%' : '90%',
                }}
                onClick={() => setShowForm(true)}
              >
                Yes! I Want This Secret Pack
              </button>
              <p style={{fontSize:'20px'}}>Just ₹199 Limited Time Only</p>
            </div>
          </div>
        </div>
      </div>
      {/* Popup Form */}
            {showForm && <RequestAccess onClose={() => setShowForm(false)} />}
    </>
  );
};

export default FreeMasterclass;
